import {
  ADD_AGENT,
  GET_AGENT,
  EDIT_AGENT,
  DELETE_AGENT,
  BLOCK_AGENT,
} from "../constants/action-types";

const initilState = {
  state: "",
};

const agentReducer = (state = initilState, action) => {
  switch (action.type) {
    case ADD_AGENT:
      return {
        ...state,
        ...state.data.push(action?.payload),
      };
    case GET_AGENT:
      return {
        ...state,
        data: action.payload,
      };
    case EDIT_AGENT:
      const index = state.data.findIndex(
        (ele) => ele.id === action?.payload.id
      );
      state.data.splice(index, 1, action?.payload);
      return {
        ...state,
        ...state.data,
      };
    case DELETE_AGENT:
      const deleteIndex = state.data.filter(
        (ele) => ele.id !== action?.payload.id
      );
      return {
        ...state,
        data: deleteIndex,
      };
    case BLOCK_AGENT:
      const blockIndex = state.data.findIndex(
        (ele) => ele.id === action?.payload.id
      );
      state.data.splice(blockIndex, 1, action?.payload);
      return {
        ...state,
        ...state.data,
      };
    default:
      return state;
  }
};

export default agentReducer;
